import React from 'react';
import { useIntl } from 'react-intl';
import { useDispatch } from 'react-redux';
import { push } from 'redux-first-history';

import Heading from '@starbucks-web/pattern-library/lib/components/heading/';

import { setPostStoreSelectionReturnUrl } from 'shared/app/state/action-creators/post-store-selection-return-url';
import DialogWithMessages from 'shared/app/components/dialog-with-messages';
import storeDialogMessages from 'shared/app/components/confirm-store-dialog/messages';
import { sharedCallsToAction } from 'shared/app/messages';

export const TimeSelectionErrorDialog = ({
  bodyMessage,
  dialogId,
  headingMessage,
  showChangeStoreButton,
}) => {
  const dispatch = useDispatch();
  const { formatMessage } = useIntl();

  return (
    <DialogWithMessages
      cancelText={
        showChangeStoreButton
          ? formatMessage(storeDialogMessages.changeStore)
          : null
      }
      confirmText={formatMessage(sharedCallsToAction.gotIt)}
      onCancel={
        showChangeStoreButton
          ? () => {
              dispatch(setPostStoreSelectionReturnUrl('/menu/cart'));
              dispatch(push('/menu/store-locator'));
            }
          : null
      }
    >
      <Heading className="text-lg text-semibold mb3" id={dialogId} tagName="h2">
        {headingMessage}
      </Heading>
      <p className="text-xxs">{bodyMessage}</p>
    </DialogWithMessages>
  );
};
